import React, {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";
import axios from "axios";

import * as actionTypes from "../../../store/actions/actionTypes";
import Admission_ModalInfo from "../../Block/Admission_ModalInfo";
import AdmissionDocumentPdf from "../../AdmissionDocumentPdf";

const PreviewPdf = () => {
    const {show, admission, customUI} = useSelector(state => state.modal.customUI_uploadPreviewPdf);
    const idToken = useSelector(state => state.auth.idToken);
    const dispatch = useDispatch();
    const ref = React.useRef(null);
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);

    const [patientData, setPatientData] = useState(null);
    const [patientDataDocTitle, setPatientDataDocTitle] = useState(null);
    const [patientDataEnabled, setPatientDataEnabled] = useState(false);

    const hideModal = () => dispatch({type: actionTypes.MODAL_CUSTOM_UI_UPLOAD_PREVIEW_PDF_HIDE});
    useOnClickOutside(ref, () => hideModal());

    useEffect(() => {
        if (!show || !admission || !customUI || !customUI.patientData_enable) {
            setPatientData(null);
            setPatientDataDocTitle(null);
            setPatientDataEnabled(false);
            return;
        }

        axios.get(
            `${process.env.REACT_APP_API_PATH}/admission/${admission.id}/custom-ui/${customUI.id}/pre-admission-patient-data`,
            {headers: {'Authorization': idToken}}
        ).then((response) => {
            setPatientDataEnabled(!!response.data.enabled);
            setPatientDataDocTitle(response.data.documentTitle || null);
            setPatientData(response.data.data || null);
        }).catch(() => {
            setPatientData(null);
        });
    }, [show, admission, customUI, idToken]);

    const renderPatientData = () => {
        if (!patientDataEnabled || !state_showDevUI) {
            return null;
        }
        return (
            <div style={{marginTop: '20px'}}>
                <h4>Imported patient data{patientDataDocTitle ? ` — ${patientDataDocTitle}` : ''}</h4>
                {patientData
                    ? <pre style={{maxHeight: '400px', overflow: 'auto', background: '#f7f7f7', padding: '10px', border: '1px solid #ddd'}}>{JSON.stringify(patientData, null, 2)}</pre>
                    : <p><em>No patient data imported.</em></p>}
            </div>
        );
    };

    const renderModal = () => {
        if (show) {
            return (
                <div className="modal-dialog modal-wide" role="document" ref={ref} autoFocus={false}>
                    <div className="modal-content modal-content-fit">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={hideModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                        <div className="modal-body">
                            <h3>{admission.title} {admission.surname}, {admission.name}</h3>
                            <Admission_ModalInfo admission={admission} showMobileInfo={false} />
                            <AdmissionDocumentPdf admissionId={admission.id} type={'customUIPDF'} width={1075} subType={customUI.id}/>
                            {renderPatientData()}
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="personModal" tabIndex="-1" role="dialog"
                 aria-labelledby="personModalLabel" aria-modal="true">
                {renderModal()}
            </div>
        </>
    );
}

export default PreviewPdf;
